import * as React from 'react'
import { ReactElement } from 'react'
import Note from '../../Note/Note'
import { css, getTheme, mergeStyleSets, Stack, StackItem } from '@fluentui/react'
import { DataPromise } from '../../../context/AxiosContext'
import { NoteOverviewDto } from '../../../config/noteConfig'
import Loading from '../../../components/Loading'
import useUser from '../../../hooks/useUser'
import { Card } from '@fluentui/react-components'

export type NoteListProps = {
    notes: DataPromise<NoteOverviewDto[]>
}

const theme = getTheme()
const styles = mergeStyleSets({
    stack: { marginLeft: theme.spacing.s1, marginRight: theme.spacing.s1 },
    // https://stackoverflow.com/questions/37745051/make-div-fill-remaining-horizontal-space-in-flexbox
    note: { flex: 1, maxWidth: 480 },
    card: { margin: 0 },
})

export default function NoteList(props: NoteListProps): ReactElement {
    const currentUser = useUser()
    const emptyNote: NoteOverviewDto = {
        id: null,
        content: '',
        isPrivate: false,
        createdByAuthor: currentUser,
        createdAt: null,
        updatedByAuthor: null,
        updatedAt: null,
        revisionCount: 0,
    }

    if (!props.notes.loaded) {
        return <Loading />
    }

    return (
        <Stack horizontal horizontalAlign="start" wrap tokens={{ childrenGap: 'm' }} className={css(styles.stack)}>
            {[emptyNote, ...props.notes.data].map(note => (
                <StackItem grow className={css(styles.note)} key={note.id || 'empty-note'}>
                    <Card className={css(styles.card)}>
                        <Note {...note} />
                    </Card>
                </StackItem>
            ))}
        </Stack>
    )
}
